import { render, staticRenderFns } from "./dot-btn.vue?vue&type=template&id=55a99928&scoped=true&lang=pug&"
import script from "./dot-btn.vue?vue&type=script&lang=js&"
export * from "./dot-btn.vue?vue&type=script&lang=js&"
import style0 from "./dot-btn.vue?vue&type=style&index=0&id=55a99928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a99928",
  null
  
)

export default component.exports